import {ViewType} from "../../../view_type/ViewType";
import {IApplicationReducerData} from "../../types/IApplicationReducerData";
import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {AmplitudeLeadFormLocation, getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

export interface IGetAmplitudeCtaLeadFormTrackingContextParams {
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    leadData: IApplicationReducerData | undefined;
    ctaText: string;
    offerId?: number | null;
    propertyId?: number | null;
    viewType: ViewType | null;
    /** Set by placements the lead data can't identify on its own (e.g. the apartment configurator). */
    formLocation?: AmplitudeLeadFormLocation;
}

export const getAmplitudeCtaLeadFormTrackingContext = (params: IGetAmplitudeCtaLeadFormTrackingContextParams): IAmplitudeLeadFormTrackingContext | null => {
    const {source, sourceSection, leadData, ctaText, viewType, formLocation} = params;
    const offerId = leadData?.offer?.detail?.id ?? params.offerId;
    const propertyId = leadData?.property?.detail?.id ?? params.propertyId;
    const isVendorOnly = source === ApplicationSource.Vendor && !offerId && !propertyId;

    if (!offerId && !isVendorOnly) {
        return null;
    }

    const preferredLocation = formLocation ?? getAmplitudePreferredLocation(viewType, source) ?? (propertyId ? "property_page" : "investment_page");

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        cta_text: ctaText,
        form_location: getAmplitudeFormLocation(leadData, preferredLocation),
        source_id: source,
        lead_type: getAmplitudeLeadType(sourceSection),
        ...(offerId != null && {item_id: offerId}),
        ...(propertyId != null && {property_id: propertyId})
    };
};

const getAmplitudePreferredLocation = (viewType: ViewType | null, source: ApplicationSource): AmplitudeLeadFormLocation | null => {
    if (source === ApplicationSource.Vendor) {
        return "vendor_page";
    }

    if (source === ApplicationSource.PropertyConfigurator) {
        return "property_configurator";
    }

    switch (viewType) {
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
            return "listing_map";
    }

    return null;
};
import {ViewType} from "../../../view_type/ViewType";
import {IApplicationReducerData} from "../../types/IApplicationReducerData";
import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {AmplitudeLeadFormLocation, getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

export interface IGetAmplitudeCtaLeadFormTrackingContextParams {
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    leadData: IApplicationReducerData | undefined;
    ctaText: string;
    offerId?: number | null;
    propertyId?: number | null;
    viewType: ViewType | null;
    /** Set by placements the lead data can't identify on its own (e.g. the apartment configurator). */
    formLocation?: AmplitudeLeadFormLocation;
}

export const getAmplitudeCtaLeadFormTrackingContext = (params: IGetAmplitudeCtaLeadFormTrackingContextParams): IAmplitudeLeadFormTrackingContext | null => {
    const {source, sourceSection, leadData, ctaText, viewType, formLocation} = params;
    const offerId = leadData?.offer?.detail?.id ?? params.offerId;
    const propertyId = leadData?.property?.detail?.id ?? params.propertyId;
    const isVendorOnly = source === ApplicationSource.Vendor && !offerId && !propertyId;

    if (!offerId && !isVendorOnly) {
        return null;
    }

    const preferredLocation = formLocation ?? getAmplitudePreferredLocation(viewType, source) ?? (propertyId ? "property_page" : "investment_page");

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        cta_text: ctaText,
        form_location: getAmplitudeFormLocation(leadData, preferredLocation),
        source_id: source,
        lead_type: getAmplitudeLeadType(sourceSection),
        ...(offerId != null && {item_id: offerId}),
        ...(propertyId != null && {property_id: propertyId})
    };
};

const getAmplitudePreferredLocation = (viewType: ViewType | null, source: ApplicationSource): AmplitudeLeadFormLocation | null => {
    if (source === ApplicationSource.Vendor) {
        return "vendor_page";
    }

    if (source === ApplicationSource.PropertyConfigurator) {
        return "property_configurator";
    }

    switch (viewType) {
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
            return "listing_map";
    }

    return null;
};
